import { useEffect, useState } from "react";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import '../css/form.css'
import { useDispatch } from "react-redux";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import Mode from "../components/styles/Mode";

const Disqualify = () => {

    const dispatch = useDispatch()


    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))


        const urlParams = new URLSearchParams(window.location.search)
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        setFirstName(first_name)
        setLastName(last_name)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="dq-page" style={{ background: 'white' }}>
                {(firstName && lastName) && <div className="margin-auto error-div">
                    <div style={{ textAlign: 'center', padding: 20 }}>
                        <Spacebox padding="20px" />
                        <Flexbox alignItems="center" justifyContent="center">
                            <img src="/assets/color-logo.png" alt="Final debt relief" style={{ width: 200 }} />
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Flexbox justifyContent="space-between" alignItems="center">
                            <div>
                                <span>
                                    Name: <b>{firstName} {lastName}</b>
                                </span>
                                <Spacebox padding="0px" />
                                <span>
                                    Date: <b>{(new Date()).toString().substring(4, 16)}</b>
                                </span>
                            </div>
                        </Flexbox>
                        <Spacebox padding="20px" />
                        <div className="margin-auto" style={{ textAlign: 'center', maxWidth: 500 }}>
                            <div style={{ width: 'fit-content' }} className="margin-auto">
                                <img src="/assets/green-check.png" alt="check" style={{ width: 40 }} />
                            </div>
                            <Spacebox padding="20px" />
                            <span style={{ fontSize: 25, fontWeight: 600 }} className="trade-green">
                                Thank You — We’ve Received Your Info!
                            </span>
                            <Spacebox padding="10px" />
                            <span>
                                Unfortunately, we do not currently offer our services in your state. We understand how frustrating this can be, and we truly appreciate your interest in working with us.
                            </span>
                            <Spacebox padding="20px" />
                        </div>
                    </div>
                </div>}
            </div>
        </Mode>
    );
}

export default Disqualify;